import "./style.css";

import { useState, useEffect } from "react";

import axios from "axios";

import { useParams } from "react-router-dom";

import { toast } from "react-toastify";

function Login() {

    const [isActive, setIsActive] = useState(false);

    const { company } = useParams();

    const [companyValid, setCompanyValid] = useState(null);

    const [loginData, setLoginData] = useState({
        email: "",
        password: "",
    });

    const [registerData, setRegisterData] = useState({
        name: "",
        username: "",
        email: "",
        password: "",
    });


    useEffect(() => {

        if (!company) {

            setCompanyValid(true);

            return;
        }

        const checkCompany = async () => {

            try {

                await axios.get(

                    `/api/companies/by-subdomain/${company}`

                );

                setCompanyValid(true);

            } catch (error) {

                console.log(error);

                setCompanyValid(false);
            }
        };

        checkCompany();

    }, [company]);


    // =========================
    // EMPRESA NO CARGADA
    // =========================

    if (companyValid === null) {

        return (

            <h2
                style={{
                    textAlign: "center",
                    marginTop: "100px"
                }}
            >

                Cargando...

            </h2>

        );
    }


    // =========================
    // EMPRESA NO EXISTE
    // =========================

    if (companyValid === false) {

        return (

            <div
                style={{
                    textAlign: "center",
                    marginTop: "100px"
                }}
            >

                <h1>

                     Empresa no encontrada

                </h1>

                <p>

                    Verifica la URL o contacta al administrador

                </p>

            </div>

        );
    }


    // =========================
    // HANDLE INPUT LOGIN
    // =========================

    const handleLoginChange = (e) => {

        setLoginData({

            ...loginData,

            [e.target.name]: e.target.value,

        });
    };


    // =========================
    // HANDLE INPUT REGISTER
    // =========================

    const handleRegisterChange = (e) => {

        setRegisterData({

            ...registerData,

            [e.target.name]: e.target.value,

        });
    };


    // =========================
    // LOGIN
    // =========================

    const handleLogin = async (e) => {

        e.preventDefault();

        try {

            const res = await axios.post(

                "/api/auth/login",

                {

                    email: loginData.email,

                    password: loginData.password,

                    // puedes quitarlo después
                    company: company,

                }

            );

            localStorage.setItem(

                "token",

                res.data.access_token

            );


            toast.success(

                "Bienvenido al sistema"

            );


            setTimeout(() => {

                window.location.href = "/dashboard";

            }, 1200);


        } catch (error) {

            console.log(error.response);

            toast.error(

                error.response?.data?.detail ||

                "Error al iniciar sesión"

            );
        }
    };


    // =========================
    // REGISTER
    // =========================

    const handleRegister = async (e) => {

        e.preventDefault();

        try {

            await axios.post(

                "/api/users/",

                {

                    name: registerData.name,

                    email: registerData.email,

                    password: registerData.password,

                }

            );


            toast.success(

                "Usuario registrado correctamente"

            );


            setIsActive(false);

        } catch (error) {

            console.log(error.response);

            toast.error(

                error.response?.data?.detail ||

                "Error al registrar usuario"

            );
        }
    };


    return (

        <div className={`container ${isActive ? "active" : ""}`}>

            {/* REGISTRO */}

            <div className="form-container sign-up">

                <form onSubmit={handleRegister}>

                    <h1>

                        Crear Cuenta

                    </h1>

                    <span>

                        Completa los siguientes datos

                    </span>

                    <input

                        type="text"

                        name="name"

                        placeholder="Nombre completo"

                        value={registerData.name}

                        onChange={handleRegisterChange}

                        required

                    />

                    <input

                        type="text"

                        name="username"

                        placeholder="Usuario"

                        value={registerData.username}

                        onChange={handleRegisterChange}

                        required

                    />

                    <input

                        type="email"

                        name="email"

                        placeholder="Correo electrónico"

                        value={registerData.email}

                        onChange={handleRegisterChange}

                        required

                    />

                    <input

                        type="password"

                        name="password"

                        placeholder="Contraseña"

                        value={registerData.password}

                        onChange={handleRegisterChange}

                        required

                    />

                    <button type="submit">

                        Crear

                    </button>

                </form>

            </div>


            {/* LOGIN */}

            <div className="form-container sign-in">

                <form onSubmit={handleLogin}>

                    <h1>

                        Iniciar sesión

                    </h1>

                    <span>

                        Usa tu usuario o correo y contraseña

                    </span>

                    <div className="input-group">

                        <input

                            type="email"

                            name="email"

                            value={loginData.email}

                            onChange={handleLoginChange}

                            required

                        />

                        <label>

                            Usuario o correo

                        </label>

                    </div>


                    <div className="input-group">

                        <input

                            type="password"

                            name="password"

                            value={loginData.password}

                            onChange={handleLoginChange}

                            required

                        />

                        <label>

                            Contraseña

                        </label>

                    </div>


                    <a

                        href="/recuperar-password"

                        className="forgot-password"

                    >

                        ¿Olvidaste tu contraseña?

                    </a>


                    <button type="submit">

                        Ingresar

                    </button>

                </form>

            </div>


            {/* PANEL */}

            <div className="toggle-container">

                <div className="toggle">


                    <div className="toggle-panel toggle-left">

                        <h1>

                            ¡Bienvenido de nuevo!

                        </h1>

                        <p>

                            Tu contabilidad, clara y conectada.

                        </p>

                        <button

                            className="hidden"

                            onClick={() => setIsActive(false)}

                        >

                            Ingresar

                        </button>

                    </div>


                    <div className="toggle-panel toggle-right">

                        <h1>

                            Hola, amigo!

                        </h1>

                        <p>

                            Regístrate con tus datos personales para acceder

                            a todas las funciones del sistema.

                        </p>

                        <button

                            className="hidden"

                            onClick={() => setIsActive(true)}

                        >

                            Registrarse

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );
}

export default Login;